(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("VueRouter"), require("Vue"));
	else if(typeof define === 'function' && define.amd)
		define(["VueRouter", "Vue"], factory);
	else if(typeof exports === 'object')
		exports["billing-front-app"] = factory(require("VueRouter"), require("Vue"));
	else
		root["billing-front-app"] = factory(root["VueRouter"], root["Vue"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__6389__, __WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 